<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <!--Boxicons v3.0.8 https://boxicons.com | License  https://docs.boxicons.com/free-->
    <path
      d="M20 3H7c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2h8c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2M10 19H4V9h6zm10-2h-8V9c0-1.1-.9-2-2-2H7V5h13z"
    ></path>
  </svg>
</template>
